import React from "react";

const SIZE = 760;
const CENTER = SIZE / 2;
const R = 150;

// Eight circles, each centred a distance R from the shared point and sized
// with radius R, so every circle's edge passes through that point. The
// result is a flower of overlapping domains that all converge in one place.
const domains = [
  "Strategy",
  "User research",
  "Service design",
  "Enterprise architecture",
  "Startup & founder",
  "Data science",
  "Agentic AI",
  "Engineering craft",
];

const polar = (angleDeg, radius) => {
  const rad = (angleDeg - 90) * (Math.PI / 180);
  return { x: CENTER + radius * Math.cos(rad), y: CENTER + radius * Math.sin(rad) };
};

const CombinationDiagram = () => (
  <svg viewBox={`0 0 ${SIZE} ${SIZE}`} className="mx-auto w-full max-w-md" aria-hidden="true">
    <g className="text-accent" fill="currentColor" stroke="currentColor">
      {domains.map((d, i) => {
        const angle = (360 / domains.length) * i;
        const c = polar(angle, R);
        return (
          <circle
            key={d}
            cx={c.x}
            cy={c.y}
            r={R}
            fill="currentColor"
            fillOpacity={0.055}
            stroke="currentColor"
            strokeOpacity={0.35}
            strokeWidth={1}
          />
        );
      })}
    </g>
    {domains.map((d, i) => {
      const angle = (360 / domains.length) * i;
      const label = polar(angle, 2 * R + 18);
      return (
        <text
          key={d}
          x={label.x}
          y={label.y}
          textAnchor="middle"
          dominantBaseline="middle"
          className="fill-ink-soft font-mono"
          fontSize="13"
        >
          {d}
        </text>
      );
    })}
    <circle cx={CENTER} cy={CENTER} r={5} className="fill-ink" />
    <text
      x={CENTER}
      y={CENTER - 16}
      textAnchor="middle"
      className="fill-ink font-mono font-semibold"
      fontSize="13"
      letterSpacing="1"
    >
      ME
    </text>
  </svg>
);

export default CombinationDiagram;
